import { metrics } from "@north-beam/nb-common";

export type MetricName =
  | "totalNumOrders"
  | "totalOrderValue"
  | "totalOrderValueExclRefunds"
  | "totalReorders";

export const METRIC_OPTIONS = {
  totalOrderValue: "Customer Value",
  totalOrderValueExclRefunds: "Customer Value (with Refunds)",
  totalNumOrders: "Orders per customer",
  totalReorders: "% Reordering",
} as const;

export const METRIC_FORMATS = {
  totalOrderValue: metrics.MetricTypes.CURRENCY,
  totalOrderValueExclRefunds: metrics.MetricTypes.CURRENCY,
  totalNumOrders: metrics.MetricTypes.INTEGER,
  totalReorders: metrics.MetricTypes.PERCENTAGE,
} as const;

export const ROWS_PER_PAGE = 50;

export const DEFAULT_SORT_BY = "breakdown";
